import {
  SOCIAL_USER_PROFILE_UPDATE_BEGIN,
  SOCIAL_USER_PROFILE_UPDATE_SUCCESS,
  SOCIAL_USER_PROFILE_UPDATE_ERROR,
} from './constants';

export const socialUserProfileUpdateBegin = () => ({
  type: SOCIAL_USER_PROFILE_UPDATE_BEGIN,
});

export const socialUserProfileUpdateSuccess = payload => ({
  type: SOCIAL_USER_PROFILE_UPDATE_SUCCESS,
  payload,
});

export const socialUserProfileUpdateError = payload => ({
  type: SOCIAL_USER_PROFILE_UPDATE_ERROR,
  payload,
});
